import { UserCoverageAndSelections } from '../use-coverage';
import { Category, SubCategory, SubSubCategory, Warranty, WarrantyTitle } from '../../../constants';
import { CoverageScreenType } from './coverage-type';

const subAndCategoryMapping = ({ category, subcategory, subsubcategory }: Partial<UserCoverageAndSelections>) => {
  const mappings = new Map(
    Object.entries({
      [SubCategory.Electrical]: 'electrical',
      [SubCategory.Engine]: 'engine',
      [SubCategory.Steering]: 'steering',
      [SubCategory.Suspension]: 'suspension',
      [SubCategory.Transmission]: 'transmission',
      [SubCategory.Gas]: 'battery',
      [SubCategory.ElectricOrHybrid]: 'EV and hybrid battery pack',
      [Category.HeatingAndCooling]: 'heating and cooling',
      [SubCategory.Brakes]: 'brake',
      [SubCategory.Tires]: 'tire',
      [SubCategory.Wheels]: 'wheel',
      [SubSubCategory.Dents]: 'minor dent',
      [SubCategory.KeyNotWorking]: 'key',
      [SubCategory.AdditionalKey]: 'additional keys',
      [SubCategory.MissingFloorMats]: 'missing accessories',
      [SubCategory.MissingOtherAccessories]: 'missing accessories',
    })
  );

  return (
    mappings.get(subcategory || '') ||
    mappings.get(category || '') ||
    mappings.get(subsubcategory || '') ||
    subcategory?.toLowerCase()
  );
};

const formatInlineWarranty = (warranty: Warranty) => {
  const warrantyString = WarrantyTitle[warranty];
  if (warrantyString && warrantyString?.includes('CarvanaCare')) {
    return `${warrantyString?.replace('CarvanaCare', 'CarvanaCare®')} plan`;
  }
  return warrantyString;
};

export const CoverageScreenTitle = {
  contactUs: () => 'Contact an Advocate',
  limited100Covered: (userSelections) =>
    `Good news! Most ${subAndCategoryMapping(userSelections)} issues are covered under your 100-day Limited Warranty`,
  manufacturerCovered: (userSelections) =>
    `Good news! Most ${subAndCategoryMapping(userSelections)} issues are covered under your manufacturer warranty.`,
  carvanaCareCovered: (userSelections) =>
    `Good news! Most ${subAndCategoryMapping(userSelections)} issues are covered under your CarvanaCare® plan`,
  carvanaCareRoadHazardCovered: (userSelections) =>
    `Good news! Most ${subAndCategoryMapping(userSelections)} damage is covered under your CarvanaCare® plan`,
  carvanaCareRoadHazardNotCovered: (userSelections) =>
    `Sorry, you aren't covered for this ${subAndCategoryMapping(userSelections)} issues`,
  carvanaCareOilChangeCovered: () =>
    `Good news! Oil changes and tire rotations are covered under your CarvanaCare® plan.*`,
  carvanaCareOilChangeNotCovered: () => `Sorry, you aren't covered for maintenance services`,
  carvanaCareDentCovered: () => `Paintless dent repairs are covered under your CarvanaCare® plan.`,
  carvanaCareOilTireCovered: () => `Good news! Your CarvanaCare® plan comes with oil changes and tire rotations.`,
  notCovered: (userSelections) =>
    userSelections?.category === Category.Maintenance
      ? `Sorry, you aren't covered for maintenance services`
      : `Sorry, you aren't covered for ${subAndCategoryMapping(userSelections)} issues`,
  thirtyDayCovered: (userSelections) => `Most ${subAndCategoryMapping(userSelections)} issues aren't covered`,
  conditionallyCoveredBrakes: ({ warranty }) =>
    `Sorry, most brake issues aren't covered under your ${formatInlineWarranty(warranty)}`,
  notCoveredCosmetic: () => `Sorry, you aren't covered for cosmetic issues`,
  notCoveredGlass: () => `Sorry, you aren't covered for glass issues or defects`,
  notCoveredAdditionalCosmetic: () => `Sorry, you aren't covered for additional cosmetic issues`,
  notCoveredAdditionalKey: () => `Sorry, you aren't covered for additional keys`,
  notCoveredMissingAccessories: () => `Sorry, you aren't covered for missing accessories`,
  cosmeticSubmitted: () => 'Your issue is submitted',
};

export const getTitle = (coverageScreenType: CoverageScreenType, userSelections: UserCoverageAndSelections): string => {
  return CoverageScreenTitle[coverageScreenType](userSelections);
};
